import type { MemoryFeastAction } from "@cloudnest/memory-feast-engine";

/**
 * Typed replay-event adapter for 기억의 만찬 (memory-feast).
 *
 * Hidden-information game: bowl counts are server-authoritative. The replay
 * fixture carries the authoritative state in `init` for post-game review, and
 * the replay screen masks covered bowls in the DOM (see ReplayScreen). Player
 * events are `PlaceTokens` and `OpenBowls`.
 */
export type MemoryFeastReplayEventType = "init" | "PlaceTokens" | "OpenBowls";

export const MEMORY_FEAST_REPLAY_EVENT_TYPES = [
  "init",
  "PlaceTokens",
  "OpenBowls",
] as const satisfies readonly MemoryFeastReplayEventType[];

export function normalizeMemoryFeastReplayEventType(
  eventType: string,
): MemoryFeastReplayEventType {
  if (
    (MEMORY_FEAST_REPLAY_EVENT_TYPES as readonly string[]).includes(eventType)
  ) {
    return eventType as MemoryFeastReplayEventType;
  }
  throw new Error(`Unsupported memory-feast event type: ${eventType}`);
}

export function memoryFeastEventToAction(
  eventType: string,
  payload: Record<string, unknown>,
): MemoryFeastAction {
  const type = normalizeMemoryFeastReplayEventType(eventType);
  if (type === "init") {
    throw new Error("memoryFeastEventToAction cannot convert the init event");
  }
  const playerId = payload.playerId === "p2" ? "p2" : "p1";
  const bowlIds = (payload.bowlIds as readonly number[] | undefined) ?? [];
  if (type === "OpenBowls") {
    return { type: "OpenBowls", playerId, bowlIds };
  }
  return { type: "PlaceTokens", playerId, bowlIds };
}
